export default __webpack_public_path__ + "static/media/ES_Deprived - Guustavv.057c10e0.mp3";